const HTML = require('../../assets/images/html.png');
const CSS = require('../../assets/images/css3.png');
const JS = require('../../assets/images/js.png');
const TS = require('../../assets/images/typescript_original_logo_icon_146317.png');
const React = require('../../assets/images/1611079.png');
const Redux = require('../../assets/images/Redux.png');
const Angular = require('../../assets/images/angular.png');
const PrimeNg = require('../../assets/images/primeng-logo.png');
const Tailwind = require('../../assets/images/tailwind-css-icon-512x307-1v56l8ed.png');
const Bootstrap = require('../../assets/images/Bootstrap_logo.svg.png');
const Jest = require('../../assets/images/jest-logo-png-transparent.png');
const ReactTestingLibrary = require('../../assets/images/octopus-128x128.png');
const Firebase = require('../../assets/images/firebase.png');
const Github = require('../../assets/images/github.png');
const Git = require('../../assets/images/Git-Icon-1788C.png');

export const skills = [
  {
    id: '1',
    skill: 'HTML5',
    image: HTML,
  },
  {
    id: '2',
    skill: 'CSS3',
    image: CSS,
  },
  {
    id: '3',
    skill: 'JavaScript',
    image: JS,
  },
  {
    id: '4',
    skill: 'TypeScript',
    image: TS,
  },
  {
    id: '5',
    skill: 'React',
    image: React,
  },
  {
    id: '6',
    skill: 'Redux Toolkit',
    image: Redux,
  },
  {
    id: '7',
    skill: 'Angular',
    image: Angular,
  },
  {
    id: '8',
    skill: 'Prime Ng',
    image: PrimeNg,
  },
  {
    id: '9',
    skill: 'Tailwind CSS',
    image: Tailwind,
  },
  {
    id: '10',
    skill: 'Bootstrap',
    image: Bootstrap,
  },
  {
    id: '11',
    skill: 'Jest',
    image: Jest,
  },
  {
    id: '12',
    skill: 'React Testing Library',
    image: ReactTestingLibrary,
  },
  {
    id: '13',
    skill: 'Firebase',
    image: Firebase,
  },
  {
    id: '14',
    skill: 'Github',
    image: Github,
  },
  {
    id: '15',
    skill: 'Git',
    image: Git,
  },
];
